<template>
  <div class="content "
       :class="{'loading-overlay loading-overlay-progress': donationsState !== 'ready'}">

    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        v-on:update-date="updateDate"

        v-on:download="download"
        :isSearchBox="false"
    >
      <template v-slot:filter>
        <div class="text-right float-right px-8 sm:px-4 pt-3">

          <el-dropdown @command="selectCampaign" trigger="click">
            <el-button type="primary" size="medium" class="w-max" style="min-width: 150px">
              {{selectedCampaign && selectedCampaign.name || 'All Campaigns'}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item v-if="selectedCampaignId" :command="null">All Campaigns</el-dropdown-item>
              <el-dropdown-item :command="-1" >--</el-dropdown-item>
              <el-dropdown-item v-for="(campaign, index) in allCampaigns"
                                :key="index"
                                :command="campaign.id"
              >{{campaign.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
      </template>
    </reports-menu>

    <div class="px-8 md:px-4 pt-4 d-reports clearfix tab-donations">
      <div class="d-block donations-summary shadow-md rounded-md bg-white">
        <h3 class="title">
          <div class=" flex flex-wrap -mx-2">
            <div class="px-2 w-1/2">Campaigns</div>
            <div class="px-2 w-1/2 text-right "><span>{{ selected(startDate, endDate) | intervalLabel }}</span></div>
          </div></h3>

        <div class="contacts-list campaign-donations-list">
          <div id="c-donations-table_wrapper">

            <el-table
                style = "width: 100%"
                :default-sort = "sorting"
                :data = "itemsDataPage"
                :height="tableHeight + 110"
                v-on:sort-change="sortChange"
            >
              <template  slot="empty">
                <div v-if="donationsState !== 'ready' || loading" slot="empty">Loading data...</div>
                <div v-else class="empty-placeholder">
                  <img :src="require('../../assets/paceholders/31.svg')" alt="No results">
                  <h3>No Campaign Donations Yet</h3>
                </div>

              </template>

              <el-table-column label="Date Created"
                               prop="created_at"
                               :sort-orders="['descending', 'ascending']"
                               sortable="custom"
                               width="150"
              >
                <template slot-scope="scope">
                  {{scope.row.created_at | dateFormat('MMM DD, YYYY')}}
                  <div class="info">{{scope.row.created_at | dateFormat('h:mma')}}</div>
                </template>
              </el-table-column>

              <el-table-column label="Name & Email"
                               prop="_full_name"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="300"
              >
                <template slot-scope="scope">
                  <div class="donor">
                    <span v-if="scope.row.is_guest">{{scope.row.first_name}} {{scope.row.last_name}}</span>
                    <span v-else class="show-donor-info"
                          v-on:click.prevent="showDonorSidebar(scope.row.uid)"
                    >{{scope.row.first_name}} {{scope.row.last_name}}</span>
                    <div class="info">{{scope.row.email}}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="Donation Type"
                               prop="type"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="150"
              >
                <template slot-scope="scope">
                  <span :class="{
                    'txt-orange': scope.row.type === 'custom',
                    'txt-green': scope.row.type === 'recurring',
                    'txt-blue': (scope.row.type !== 'recurring' && scope.row.type !== 'custom')
                  }">{{getDonationTypeTitle(scope.row.type)}}</span>
                  <div class="info">Type</div>
                </template>
              </el-table-column>

              <el-table-column label="Total Donation"
                               prop="amount"
                               sortable="custom"
                               :sort-orders="[ 'descending', 'ascending']"
                               min-width="150"
              >
                <template slot-scope="scope">
                  <span content="Click to download receipt"
                        v-tippy
                        style="cursor: pointer; outline: none;"
                        v-on:click="$refs.receipt.generatePdf(scope.row, activeCharityInfo);">
                  ${{scope.row.amount / 100 | formatMoney(0, 9)}}<br>
                  <div style="display: inline-block" class="info">Net Total</div>
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="Campaign"
                               prop="campaign"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="250"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.campaign && scope.row.campaign_id">
                    <router-link :to="{name: 'campaign', params: {campaignId: scope.row.campaign_id}}">
                      {{scope.row.campaign}}
                    </router-link>
                  </div>
                  <div v-else>{{scope.row.campaign || '--'}}</div>
                  <div class="info">Campaign</div>
                </template>
              </el-table-column>

              <el-table-column label=""
                               width="75"
              >
                <template slot-scope="scope">

                  <el-dropdown trigger="click"
                               @command="handleCommand"
                  >
                  <span class="el-dropdown-link inline-block text-gray-500 text-xl rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                    <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
                  </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="['edit', scope.row]">Edit Campaign</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                </template>
              </el-table-column>

            </el-table>
            <el-pagination
                class="text-right"
                background
                :current-page.sync="currentPage"
                layout="prev, pager, next"
                :page-size="paginationInfo.pageSize"
                :total="itemsData.length">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <modal v-if="editModal"
           v-on:close-modal="editModal = false;"
           class="list-modal-wrap"
           :modal-name="'message-turn-off'">

      <div slot="header">
        <div class="info">Edit Campaign</div>
      </div>
      <div slot="body" class="desc">
        <div class="input-control form-item">
          <label>Full Name</label>
          <div class="name"><b>{{selectedDonation.first_name}} {{selectedDonation.last_name}}</b></div>
        </div>

        <div class="input-control form-item">
          <label>Amount</label>
          <div class="name"><b>${{selectedDonation.amount/100 | formatMoney}}</b></div>
        </div>

        <div v-if="allCampaigns && allCampaigns.length>0" class="input-control">
          <label for="edit-cmp">Campaign</label>
          <select
              id="edit-cmp"
              class="form-control"
              v-model="editParams.campaign_id"
          >
            <option :value="null">Area of Greatest Need</option>
            <option v-for="campaign in allCampaigns"
                    :key="campaign.id"
                    :value="campaign.id">{{campaign.name}}</option>
          </select>
        </div>

      </div>
      <template slot="footer">
        <div>
          <a v-on:click.prevent="editModal = false"
             href="#" class="cancel">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="editDonation(selectedDonation);editModal = false; "
                  class="btn btn-sm btn-add-to-message"
          >Save Changes
          </button>
        </div>
      </template>
    </modal>


    <receipt ref="receipt"></receipt>
  </div>
</template>

<script>
import {formatMoney} from '@/utils/utils';
  import ReportsMenu from './menu.vue';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import reportsMixin from './reports-mixin';
  import reportsMenuMixin from './reports-menu-mixin';
  import dataTableMixin from '../Parts/data-table-mixin';
  import Modal from '../Modal/index.vue';
  import Receipt from '../Receipt';
  import {mapActions, mapState} from 'vuex';

  const moment = require('moment');

  export default {
    name: 'ReportCampaigns',
    mixins: [reportsMixin, reportsMenuMixin, dataTableMixin],
    components: {
      ReportsMenu,
      DonorInfo,
      Receipt,
      Modal,
    },
    metaInfo: {
      title: 'Reports - Campaigns',
    },
    created() {
      this.sorting = {prop: 'created_at', order: 'descending'};
    },
    mounted() {
      this.updateCampaigns({charity_id: this.activeCharityId});
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command){
          case 'edit':
            this.openEditModal(payload)
            break
        }
      },
      sortChange(sorting) {
        this.sorting = sorting
      },
      selectCampaign(id){
        this.selectedCampaignId = id;
      },
      openEditModal(donationInfo){
        this.selectedDonation = donationInfo;
        this.editParams.campaign_id = donationInfo.campaign_id;

        this.editModal = true;
      },
      editDonation(donationInfo){
        this.$store.dispatch('donations/editDonationNode', {
          charityId: this.activeCharityId,
          donationId: donationInfo.id,
          params: {"campaign_id": this.editParams.campaign_id}
        })
            .then(() => this.$message('Donation updated'))
            .catch(err => alert(err));
      },
      ...mapActions('campaigns', [
        'updateCampaigns',
      ]),
      async download(type) {

        const title = `Donations to ` + (this.selectedCampaign && this.selectedCampaign.name || 'All Campaigns');

        let header = [
          'Date', 'Time',
          ...(type === 'csv' ? ['First Name', 'Last Name'] : ['Name']),
          'Email',
          'Donation Type',
          ...(type === 'csv' ? [
            'Campaign',
            'Honoree',
            'From Name',
            'Honor OR Memory',
            'In Honor/Memory Message',
            'Method of Delivery',
            'Honoree Email',
            'Honoree Address'
          ] : []),
          'Intended Amount',
          ...(type === 'csv' ? ['Donation Note'] : []),
          'Fees Covered',
          ...(type === 'csv' ? ['Harness Fee', 'Stripe Fee'] : []),
          'Total Donation',
        ];


        const body = this.itemsDataSorted.map(item => {

          const dt = moment(item.created_at);
          return [
            dt.format('MMM D, YYYY'),
            dt.format('h:mma'),
            ...(type === 'csv' ? [item.first_name, item.last_name] : [item.first_name + ' ' + item.last_name]),
            item.email,
            this.getDonationTypeTitle(item.type),
            ...(type === 'csv' ? [
              item.campaign || '',
              item.metadata && item.metadata.honor && item.metadata.honor.name || '',
              item.metadata && item.metadata.honor && item.metadata.honor.from || '',
              item.metadata && item.metadata.honor && item.metadata.honor.type || '',
              item.metadata && item.metadata.honor && item.metadata.honor.message || '',
              item.metadata && item.metadata.honor && item.metadata.honor.method || 'none',
              item.metadata && item.metadata.honor && item.metadata.honor.email || '',
              item.metadata && item.metadata.honor && item.metadata.honor.address || '',
            ] : []),
            '$' + formatMoney(item.intended_amount / 100, 2, 9),
            ...(type === 'csv' ? [item.note || ''] : []),

            '$' + formatMoney(item.covered_fee / 100, 2, 9),

            ...(type === 'csv' ? [
              '$' + formatMoney(item.platform_fee / 100, 2, 9),
              '$' + formatMoney((item.stripe_fee - item.platform_fee) / 100, 2, 9),
            ] : []),

            '$' + formatMoney(item.amount / 100, 2, 9),
          ];
        });

        this.exportData(type, title, header, body, {
          0: {minCellWidth: 25},
          1: {minCellWidth: 20},
        });
      },
    },
    computed: {
      ...mapState({
        allCampaigns: state => state.campaigns.allCampaigns,
        donations: state => state.donations.donations,
        donationsState: state => state.donations.donationsState,
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      selectedCampaign() {
        if (!this.allCampaigns || !this.selectedCampaignId) {
          return null;
        }

        if (this.selectedCampaignId === -1) {
          return {name: '--'}
        }

        return this.allCampaigns.find(c => Number(c.id) === Number(this.selectedCampaignId));
      },
      itemsData() {
        let donationsData = JSON.parse(JSON.stringify(this.donationsData));

        if(this.selectedCampaignId){
          donationsData = donationsData.filter(d => {
            if(this.selectedCampaignId === -1 && !d.campaign_id){
              return true;
            }
            return Number(d.campaign_id) === Number(this.selectedCampaignId)
          });
        }

        donationsData = donationsData.map(d => ({
          ...d,
          intended_amount: Number(d.covered_fee) > 0 ? d.amount - Number(d.covered_fee) : d.amount,
          covered_fee: Number(d.covered_fee),
          fees: parseFloat(d.stripe_fee),
          net_total: d.amount - parseFloat(d.stripe_fee),
        }));

        return this.donationsFillCampaigns(donationsData, this.allCampaigns);
      },
    },
    watch: {
      'activeCharityId'() {
        this.updateCampaigns({charity_id: this.activeCharityId});
      },
    },
    data() {
      return {
        showDonorInfo: false,
        showDonorId: null,
        selectedCampaignId: null,

        selectedDonation: null,

        editModal: false,

        editParams: {
          campaign_id: null,
        },

      };
    },
  };
</script>
